// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-boletos {
  margin-top: -30px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/boletos/boletos.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;AACJ","sourcesContent":["app-boletos {\n    margin-top: -30px;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
